import RxPaper from "./RxPaper";

export default RxPaper;
